import { useCallback } from 'react';
import api from '../../../services/api';

// Faz 2 Plan 2 (spec §5) — toplu hatırlatma. PerformanceRemindersController rotaları (BE ile birebir):
//   POST v1/performance-reminders/preview {periodId, taskIds? | criteria?, sourceInsightId?, sourceActionId?, pageNumber, pageSize, previewHash?}
//        → {recipientCount, taskCount, skipped{kod:n}, excluded{kod:n}, quietHoursUntil, previewHash, recipients{data,totalRowCount}}
//        1. sayfa göndericinin önizleme görüntüsünü yeniler (yeni belirteç); sonraki sayfalar belirteci geri yollar, görüntü aynı kalır.
//   POST v1/performance-reminders         {..., previewHash} → {batchId, recipientCount, taskCount, skippedCount}
//        Onay, görüntüdeki alıcılardan onay anında hâlâ hatırlatılabilir olanlara gider (önizlemeden sonra kapsama girenler eklenmez).
//        409 performance.reminder.previewStale: belirteç eskidi/kullanıldı/süresi doldu (yeniden önizlenir, tost yerine çekmece uyarısı)
export const PAGE_SIZE = 20;
// Büyük gönderimde çözüm ve kayıt saniyeler sürebilir; varsayılan 30 sn'de istemci vazgeçip kullanıcıyı yeniden denemeye iterdi.
export const REQUEST_TIMEOUT_MS = 120000;
export const STALE_KEY = 'performance.reminder.previewStale';

// Seçim yalnız beyan edilen alanlarla gider (boş alan gönderilmez — BE "ikisi birden" seçimi 400 sayar).
export const toRequest = (selection, extra = {}) => {
  const out = { periodId: selection?.periodId };
  if (Array.isArray(selection?.taskIds) && selection.taskIds.length > 0) out.taskIds = selection.taskIds;
  if (selection?.criteria && Object.keys(selection.criteria).length > 0) out.criteria = selection.criteria;
  if (selection?.sourceInsightId) out.sourceInsightId = selection.sourceInsightId;
  if (selection?.sourceActionId) out.sourceActionId = selection.sourceActionId;
  return { ...out, ...extra };
};

// Sayaç sözlüğü → [{code, count}] (sıfırlar atılır, büyükten küçüğe).
export const reasonList = (counts) => Object.entries(counts || {})
  .filter(([, n]) => n > 0)
  .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))
  .map(([code, count]) => ({ code, count }));

export function useReminderApi() {
  const preview = useCallback(async (selection, page = 1, previewHash = null) => {
    try {
      const extra = { pageNumber: page, pageSize: PAGE_SIZE };
      if (page > 1 && previewHash) extra.previewHash = previewHash;
      const res = await api.post('/v1/performance-reminders/preview', toRequest(selection, extra), { timeout: REQUEST_TIMEOUT_MS });
      return res?.data?.status ? res.data.data : null;
    } catch {
      return null;   // hata tostu yakalayıcıda
    }
  }, []);

  const confirm = useCallback(async (selection, previewHash) => {
    try {
      const res = await api.post('/v1/performance-reminders', toRequest(selection, { previewHash }), { skipErrorToast: [STALE_KEY], timeout: REQUEST_TIMEOUT_MS });
      return { ok: !!res?.data?.status, result: res?.data?.data || null, stale: false };
    } catch (e) {
      return { ok: false, result: null, stale: e?.response?.data?.message === STALE_KEY };
    }
  }, []);

  return { preview, confirm };
}
